import React from 'react';
import { Link } from 'react-router-dom';

const Paia = () => {
    return (
        <div className="container mx-auto px-4 py-12 max-w-4xl">
            {/* Header */}
            <div className="text-center mb-10">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-gradpath-green to-gradpath-dark rounded-2xl mb-4">
                    <i className="fas fa-file-alt text-white text-2xl"></i>
                </div>
                <h1 className="text-3xl md:text-4xl font-bold text-gradpath-dark mb-3">
                    PAIA Manual
                </h1>
                <p className="text-gray-600">
                    Promotion of Access to Information Act Manual
                </p>
                <p className="text-sm text-gray-500 mt-2">
                    In accordance with Act 2 of 2000
                </p>
            </div>

            {/* Content */}
            <div className="bg-white rounded-xl shadow-md p-6 md:p-8 space-y-6">
                <section>
                    <h2 className="text-xl font-bold text-gradpath-dark mb-3 flex items-center gap-2">
                        <i className="fas fa-info-circle text-gradpath-green text-lg"></i>
                        Introduction
                    </h2>
                    <p className="text-gray-700 leading-relaxed">
                        This manual is prepared in accordance with the Promotion of Access to Information Act 2 of 2000 (PAIA) 
                        and provides information about accessing records held by GradPath.
                    </p>
                </section>

                <section>
                    <h2 className="text-xl font-bold text-gradpath-dark mb-3 flex items-center gap-2">
                        <i className="fas fa-building text-gradpath-green text-lg"></i>
                        Company Information
                    </h2>
                    <div className="bg-gray-50 p-4 rounded-lg space-y-2">
                        <p><strong className="text-gradpath-dark">Name:</strong> GradPath (Pty) Ltd</p>
                        <p><strong className="text-gradpath-dark">Registration Number:</strong> (In process of registration)</p>
                        <p><strong className="text-gradpath-dark">Contact:</strong> <a href="mailto:support@gradpath.co.za" className="text-gradpath-green hover:underline">support@gradpath.co.za</a></p>
                        <p><strong className="text-gradpath-dark">Information Officer:</strong> Technical Director</p>
                    </div>
                </section>

                <section>
                    <h2 className="text-xl font-bold text-gradpath-dark mb-3 flex items-center gap-2">
                        <i className="fas fa-folder-open text-gradpath-green text-lg"></i>
                        Records Available Without Request
                    </h2>
                    <p className="text-gray-700 leading-relaxed mb-3">
                        The following records are automatically available to the public:
                    </p>
                    <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                        <li>Website terms and conditions</li>
                        <li>Privacy policy and PAIA manual</li>
                        <li>Job listings (publicly accessible)</li>
                        <li>Blog posts and career advice articles</li>
                        <li>Contact information</li>
                    </ul>
                </section>

                <section>
                    <h2 className="text-xl font-bold text-gradpath-dark mb-3 flex items-center gap-2">
                        <i className="fas fa-lock text-gradpath-green text-lg"></i>
                        Records Requiring Request
                    </h2>
                    <p className="text-gray-700 leading-relaxed mb-3">
                        Access to the following records requires a formal request:
                    </p>
                    <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                        <li>User account data (accessible only to the user)</li>
                        <li>Internal company records</li>
                        <li>Financial information</li>
                        <li>Technical documentation</li>
                    </ul>
                </section>

                <section>
                    <h2 className="text-xl font-bold text-gradpath-dark mb-3 flex items-center gap-2">
                        <i className="fas fa-file-signature text-gradpath-green text-lg"></i>
                        Procedure for Requests
                    </h2>
                    <p className="text-gray-700 leading-relaxed mb-3">
                        Requests for access to records must:
                    </p>
                    <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                        <li>Be made in writing (email or letter)</li>
                        <li>Be addressed to the Information Officer</li>
                        <li>Provide sufficient detail to identify the record requested</li>
                        <li>Specify the form of access required</li>
                        <li>Include proof of identity</li>
                    </ul>
                    <div className="mt-4 p-3 bg-gray-50 rounded-lg">
                        <p className="text-sm text-gray-700">
                            <strong>Email requests to:</strong> 
                            <a href="mailto:paia@gradpath.co.za" className="text-gradpath-green hover:underline ml-2">
                                paia@gradpath.co.za
                            </a>
                        </p>
                    </div>
                </section>

                <section>
                    <h2 className="text-xl font-bold text-gradpath-dark mb-3 flex items-center gap-2">
                        <i className="fas fa-credit-card text-gradpath-green text-lg"></i>
                        Fees
                    </h2>
                    <p className="text-gray-700 leading-relaxed">
                        A request fee may be applicable as prescribed by the Act. You will be notified of any fees 
                        before your request is processed. The fee structure is available upon request.
                    </p>
                </section>

                <section>
                    <h2 className="text-xl font-bold text-gradpath-dark mb-3 flex items-center gap-2">
                        <i className="fas fa-clock text-gradpath-green text-lg"></i>
                        Processing Time
                    </h2>
                    <p className="text-gray-700 leading-relaxed">
                        Requests will be processed within 30 days of receipt, unless extended for valid reasons 
                        as provided for in the Act.
                    </p>
                </section>

                <section>
                    <h2 className="text-xl font-bold text-gradpath-dark mb-3 flex items-center gap-2">
                        <i className="fas fa-ban text-gradpath-green text-lg"></i>
                        Grounds for Refusal
                    </h2>
                    <p className="text-gray-700 leading-relaxed mb-3">
                        Access may be refused to protect:
                    </p>
                    <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                        <li>Personal privacy of third parties</li>
                        <li>Commercial information of the company</li>
                        <li>Security of the platform</li>
                        <li>Legal privilege</li>
                    </ul>
                </section>

                <section>
                    <h2 className="text-xl font-bold text-gradpath-dark mb-3 flex items-center gap-2">
                        <i className="fas fa-gavel text-gradpath-green text-lg"></i>
                        Remedies Available
                    </h2>
                    <p className="text-gray-700 leading-relaxed">
                        If you are dissatisfied with a decision regarding your request, you may:
                    </p>
                    <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4 mt-3">
                        <li>Lodge an internal appeal</li>
                        <li>Apply to court for relief</li>
                        <li>Complain to the Information Regulator</li>
                    </ul>
                </section>

                <section className="bg-gray-50 p-4 rounded-lg">
                    <h2 className="text-lg font-bold text-gradpath-dark mb-2 flex items-center gap-2">
                        <i className="fas fa-info-circle text-gradpath-green"></i>
                        Information Regulator
                    </h2>
                    <p className="text-gray-700 text-sm">
                        <strong>Postal Address:</strong> P.O. Box 31533, Braamfontein, 2017<br />
                        <strong>Email:</strong> inforeg@justice.gov.za<br />
                        <strong>Website:</strong> <a href="https://www.justice.gov.za/inforeg/" target="_blank" rel="noopener noreferrer" className="text-gradpath-green hover:underline">www.justice.gov.za/inforeg/</a>
                    </p>
                </section>

                {/* Back to Home Link */}
                <div className="text-center pt-4">
                    <Link 
                        to="/" 
                        className="inline-flex items-center gap-2 text-gradpath-green hover:underline"
                    >
                        <i className="fas fa-arrow-left"></i>
                        Back to Home
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Paia;